import { useState } from "react";

import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import { useIsTouchDevice } from "hooks/useIsTouchDevice";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import faCalendar from "icons/solid/calendar-check.svg";
import trending from "icons/solid/chart-line-up.svg";
import dashboard from "icons/solid/chart-mixed.svg";
import chevronDown from "icons/solid/chevron-down.svg";
import flask from "icons/solid/flask.svg";
import scroll from "icons/solid/scroll.svg";
import yearInBooks from "icons/solid/trophy-star.svg";
import wand from "icons/solid/wand-sparkles.svg";

import MenuItem from "../MenuItem";

const labStyles =
  "hover:bg-white dark:hover:bg-gray-900 p-1 rounded-md w-full text-sm font-semibold";

export default function DiscoverMenu() {
  const loggedIn = useIsLoggedIn();
  const isTouch = useIsTouchDevice();
  const [labsExpanded, setLabsExpanded] = useState(false);

  return (
    <>
      <div className="flex flex-col w-full h-full py-2.5 justify-between items-start">
        <MenuItem
          variant="green"
          url={loggedIn ? "/feed" : "/feed/all"}
          icon={scroll}
          text="Feed"
          description="Recent activity by friends"
        />
        <MenuItem
          variant="green"
          url="/trending"
          icon={trending}
          text="Trending books"
          description="Most popular right now"
        />
        <MenuItem
          variant="green"
          url="/upcoming/month"
          icon={faCalendar}
          text="New Releases"
          description="Most anticipated "
        />
        <MenuItem
          variant="green"
          url="/recommendations"
          icon={wand}
          text="Recommendations"
          description="Just for you"
        />
      </div>
      <div className="group/lab relative bg-gray-100 dark:bg-gray-800 p-2 ">
        <Button
          className="w-full flex justify-between items-center p-1"
          onClick={() => isTouch && setLabsExpanded(!labsExpanded)}
        >
          <div className="flex gap-2 py-1">
            <Icon icon={flask} className="text-gray-500" />
            <Text className="text-sm font-semibold text-gray-300">
              Archive &amp; Labs
            </Text>
          </div>
          <Icon
            icon={chevronDown}
            size="sm"
            className={`transform transition-transform duration-150 ease-out ${
              isTouch
                ? labsExpanded
                  ? "rotate-180"
                  : ""
                : "group-hover/lab:rotate-180 group-focus-within/lab:rotate-180 group-hover/lab:ease-in group-focus-within/lab:ease-in"
            }`}
          />
        </Button>
        <div
          className={`translate-y-1 transition-all ease-in-out duration-200 text-secondary-foreground ${
            isTouch
              ? labsExpanded
                ? "block"
                : "hidden"
              : "hidden group-hover/lab:block group-focus-within/lab:block group-hover/lab:translate-y-0 group-focus-within/lab:translate-y-0"
          }`}
        >
          <Button
            className={labStyles}
            as={{
              element: "link",
              props: {
                href: "/2023",
              },
            }}
          >
            <Icon icon={yearInBooks} className="text-secondary-foreground" />
            2023 Year in Books
          </Button>
          <Button
            className={labStyles}
            as={{
              element: "link",
              props: {
                href: "/2024",
              },
            }}
          >
            <Icon icon={yearInBooks} className="text-secondary-foreground" />
            2024 Year in Books
          </Button>
          {loggedIn && (
            <Button
              className={labStyles}
              as={{
                element: "link",
                props: {
                  href: "/dashboard",
                },
              }}
            >
              <Icon icon={dashboard} className="text-secondary-foreground" />
              Dashboard
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
